import React from 'react'
import {
    Button,
    Card,
    CardHeader,
    Row,
} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import BusinessDayCell from "./BusinessDayCell";

const propTypes = {};

let resourceStrings = new LocalizedStrings(resource_strings);

class WeekDay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dayEvents: props.dayEvents,
            dayName: props.dayName,
            showEvents: props.showEvents,
            refresh: false
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            dayEvents: nextProps.dayEvents,
            dayName: nextProps.dayName
        });
    }

    render() {
        this.localize();
        return (
            <>
                <Card className="bg-transparent">
                    <CardHeader className="bg-gradient-default shadow">
                        <Row className="align-items-center">
                            <div className="col">
                                <h4 className="text-white mb-0">{this.state.dayName ? this.state.dayName : ""}</h4>
                            </div>
                            <div className="col text-right">
                                <Button
                                    color="secondary"
                                    href="#pablo"
                                    onClick={e => this.resolveAddClick(e)}
                                    size="sm"
                                >
                                    {resourceStrings.add_class}
                                </Button>
                            </div>
                        </Row>
                    </CardHeader>
                    <div style={{margin: 10}}>
                        {this.state.showEvents ? (this.state.dayEvents.length > 0 ? (this.state.dayEvents.map(e => {
                            return <BusinessDayCell event={e} className={`col-lg-12`} key={e.id}
                                                    fromCalendar={this.props.fromCalendar}
                                                    goToClass={this.props.goToClass}
                                                    openEvent={this.props.openEvent}
                                                    subUser={this.props.subUser}
                                                    showBusinessControls={true}
                            />
                        })) : (
                            <Card className="col-12 text-center">
                                <small
                                    className="text-warning mt-2 mb-2 align-center important!">{resourceStrings.no_classes}</small>
                            </Card>)) : (
                            <span/>
                        )}
                    </div>
                </Card>
            </>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        resourceStrings.setLanguage(loc);
    }

    resolveAddClick(e) {
        this.props.showOneClassModal(e, this.props.date)
    }
}

WeekDay.propTypes = propTypes;

export default WeekDay;